/**
 * API Request Response Types
 */
import { MessageParticipantRole, MessageType } from './sharedTypes';
import { EndRequestSchema, MessageMetadataSchema, SendMessageRequestSchema, StartRequestSchema, TranscriptRequestSchema } from '../schemas/apiRequestSchemas';
import { z } from 'zod';

export type StartRequest = z.infer<typeof StartRequestSchema>

export type ConnectResponse = {
    websocket: string;
};

export type SendMessageRequest = z.infer<typeof SendMessageRequestSchema>;

export type MessageMetadata = z.infer<typeof MessageMetadataSchema>;

export type ResponseMessage = {
    type: MessageType;
    messageId: string;
    content?: string;
    contentType: string;
    displayName: string;
    participantRole: MessageParticipantRole;
    absoluteTime: number;
    messageMetadata?: MessageMetadata;
};

export type SendMessageResponse = {
    message?: ResponseMessage;
};

export type EndRequest = z.input<typeof EndRequestSchema>;

export enum TranscriptScanDirection {
    FORWARD = 'FORWARD',
    BACKWARD = 'BACKWARD',
}

export enum TranscriptSortOrder {
    DESCENDING = 'DESCENDING',
    ASCENDING = 'ASCENDING',
}

export type TranscriptRequest = z.infer<typeof TranscriptRequestSchema>

export type TranscriptResponse = {
    sessionId: string;
    nextToken?: string;
    transcript: ResponseMessage[];
};
